// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"2c471635","977":"af3dfbd7"}[chunkId] + ".chunk.js";
};